import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/cdk/a11y";
function DialogModalComponent_ng_container_0_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function DialogModalComponent_ng_container_0_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.onCancel()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("btn ", ctx_r1.cancelButtonClass, "");
    i0.ɵɵattribute("aria-label", ctx_r1.cancelButtonAriaLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.cancelButtonText, " ");
} }
function DialogModalComponent_ng_container_0_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function DialogModalComponent_ng_container_0_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.onConfirm()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("btn ", ctx_r2.confirmButtonClass, "");
    i0.ɵɵattribute("aria-label", ctx_r2.confirmButtonAriaLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.confirmButtonText, " ");
} }
function DialogModalComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵlistener("keydown", function DialogModalComponent_ng_container_0_Template_div_keydown_1_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onKey($event)); });
    i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4);
    i0.ɵɵprojection(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtemplate(7, DialogModalComponent_ng_container_0_button_7_Template, 2, 5, "button", 6);
    i0.ɵɵtemplate(8, DialogModalComponent_ng_container_0_button_8_Template, 2, 5, "button", 7);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("role", ctx_r0.dialogRole)("aria-label", ctx_r0.dialogLabel)("aria-labeledby", ctx_r0.dialogLabeledby)("aria-describedby", ctx_r0.dialogDescribedby);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("cdkTrapFocusAutoCapture", true);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.cancelButtonText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.confirmButtonText);
} }
const _c0 = ["*"];
export class DialogModalComponent {
    constructor(elementRef, renderer2) {
        this.elementRef = elementRef;
        this.renderer2 = renderer2;
        this.confirmButtonText = 'OK';
        this.cancelButtonClass = 'btn-secondary';
        this.confirmButtonClass = 'btn-success';
        // a11y
        this.isAlertDialog = false;
        this.ariaDialoglabel = 'dialog';
        this.ariaDialoglabeledby = null;
        this.ariaDialogDescribedby = 'dialog-content';
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.close = new EventEmitter();
        this.cancel = new EventEmitter();
        this.confirm = new EventEmitter();
        console.warn('The component: Dialog-Modal has been deprecated and will be removed in a future release. Please update your application to use the Modal component instead. https://s3.amazonaws.com/ngx-shared/branch/5.0.0-beta/open-learning/index.html#/modal');
    }
    get isOpen() {
        return this._isOpen;
    }
    set isOpen(value) {
        if (value) {
            this.renderer2.addClass(window.document.body, 'overflow-hidden');
        }
        else {
            this.renderer2.removeClass(window.document.body, 'overflow-hidden');
        }
        this._isOpen = value;
    }
    ngOnDestroy() {
        if (this._isOpen) {
            this.renderer2.removeClass(window.document.body, 'overflow-hidden');
        }
    }
    onCancel() {
        this.onClose();
        this.cancel.emit();
    }
    onConfirm() {
        this.onClose();
        this.confirm.emit();
    }
    onKey(event) {
        if (event.key === 'Escape' && this.isOpen) {
            this.onCancel();
        }
    }
    onClose() {
        this.close.emit();
        if (this.focusElementOnClose) {
            this.focusElementOnClose.nativeElement.focus();
        }
        this.renderer2.removeClass(window.document.body, 'overflow-hidden');
    }
    get dialogRole() {
        return this.isAlertDialog ? 'alertdialog' : 'dialog';
    }
    get dialogLabel() {
        return this.ariaDialoglabeledby ? null : this.ariaDialoglabel;
    }
    get dialogLabeledby() {
        return this.ariaDialoglabeledby;
    }
    get dialogDescribedby() {
        return this.ariaDialogDescribedby;
    }
    get cancelButtonAriaLabel() {
        return this.ariaCancelLabel || this.cancelButtonText;
    }
    get confirmButtonAriaLabel() {
        return this.ariaConfirmLabel || this.confirmButtonText;
    }
}
DialogModalComponent.ɵfac = function DialogModalComponent_Factory(t) { return new (t || DialogModalComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
DialogModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DialogModalComponent, selectors: [["mhe-dialog-modal"]], inputs: { isOpen: "isOpen", focusElementOnClose: "focusElementOnClose", cancelButtonText: "cancelButtonText", confirmButtonText: "confirmButtonText", cancelButtonClass: "cancelButtonClass", confirmButtonClass: "confirmButtonClass", isAlertDialog: ["isAlert", "isAlertDialog"], ariaDialoglabel: "ariaDialoglabel", ariaDialoglabeledby: "ariaDialoglabeledby", ariaDialogDescribedby: "ariaDialogDescribedby", ariaCancelLabel: "ariaCancelLabel", ariaConfirmLabel: "ariaConfirmLabel" }, outputs: { close: "close", cancel: "cancel", confirm: "confirm" }, ngContentSelectors: _c0, decls: 1, vars: 1, consts: [[4, "ngIf"], ["tabindex", "-1", 1, "modal", "d-block", 3, "keydown"], ["cdkTrapFocus", "", "role", "document", 1, "modal-dialog", "modal-dialog-centered", 3, "cdkTrapFocusAutoCapture"], [1, "modal-content"], ["id", "dialog-content", 1, "modal-body"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 3, "class", "click", 4, "ngIf"], ["type", "button", 3, "class", "click", 4, "ngIf"], ["type", "button", "data-dismiss", "modal", 3, "click"], ["type", "button", 3, "click"]], template: function DialogModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, DialogModalComponent_ng_container_0_Template, 9, 7, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, dependencies: [i1.NgIf, i2.CdkTrapFocus], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialogModalComponent, [{
        type: Component,
        args: [{ selector: 'mhe-dialog-modal', template: "<ng-container *ngIf=\"isOpen\">\n  <div\n    class=\"modal d-block\"\n    tabindex=\"-1\"\n    [attr.role]=\"dialogRole\"\n    [attr.aria-label]=\"dialogLabel\"\n    [attr.aria-labeledby]=\"dialogLabeledby\"\n    [attr.aria-describedby]=\"dialogDescribedby\"\n    (keydown)=\"onKey($event)\"\n  >\n    <div\n      cdkTrapFocus\n      class=\"modal-dialog modal-dialog-centered\"\n      role=\"document\"\n      [cdkTrapFocusAutoCapture]=\"true\"\n    >\n      <div class=\"modal-content\">\n        <div class=\"modal-body\" id=\"dialog-content\">\n          <ng-content></ng-content>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button\n            *ngIf=\"cancelButtonText\"\n            type=\"button\"\n            class=\"btn {{ cancelButtonClass }}\"\n            data-dismiss=\"modal\"\n            [attr.aria-label]=\"cancelButtonAriaLabel\"\n            (click)=\"onCancel()\"\n          >\n            {{ cancelButtonText }}\n          </button>\n\n          <button\n            *ngIf=\"confirmButtonText\"\n            type=\"button\"\n            class=\"btn {{ confirmButtonClass }}\"\n            [attr.aria-label]=\"confirmButtonAriaLabel\"\n            (click)=\"onConfirm()\"\n          >\n            {{ confirmButtonText }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n" }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, { isOpen: [{
            type: Input,
            args: ['isOpen']
        }], focusElementOnClose: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], confirmButtonText: [{
            type: Input
        }], cancelButtonClass: [{
            type: Input
        }], confirmButtonClass: [{
            type: Input
        }], isAlertDialog: [{
            type: Input,
            args: ['isAlert']
        }], ariaDialoglabel: [{
            type: Input
        }], ariaDialoglabeledby: [{
            type: Input
        }], ariaDialogDescribedby: [{
            type: Input
        }], ariaCancelLabel: [{
            type: Input
        }], ariaConfirmLabel: [{
            type: Input
        }], close: [{
            type: Output
        }], cancel: [{
            type: Output
        }], confirm: [{
            type: Output
        }] }); })();
